import React from "react";
import "./disclaimer.scss";
import {Link} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AppFooter from "../../../components/appFooter";


export default function Disclaimer(props) {
    return (
        <div className={"mainDiv"}>
            <div className="brand-bg-inverse-color mb-3 fancyFont">
                <div className="container">
                    <nav className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
                        <Link to={"/"} className="navbar-brand">
                            <img src={require("../../../assets/logo.png")} alt="" width={"140px"}/>
                        </Link>

                    </nav>
                </div>
            </div>

            <div className="container fancyFont">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className="h3 brand-text-color inner-header">Disclaimer</h3>
                    </div>

                    <div className="col-lg-12">
                        <p>We try to keep the Services up and running and free of annoyances. But we make no promises
                            that
                            we will succeed.</p>

                        <p>The Services are provided “as is” and “as available” and to the extent permitted by law
                            without
                            warranties of any kind, either express or implied, including, but not limited to, implied
                            warranties
                            of merchantability, fitness for a particular purpose, title, and non infringement. In
                            addition, while
                            MID attempts to provide a good user experience, we do not represent or warrant that:</p>

                        <ol>
                            <li>The Services will always be secure, error-free, or timely;</li>
                            <li>The Services will always function without delays, disruptions, or imperfections; or</li>
                            <li>That any content, user content, or information you obtain on or through the Services
                                will
                                be timely or accurate.
                            </li>
                        </ol>

                        <p>MID takes no responsibility and assumes no liabilities for any content that you, another
                            user,
                            or a
                            third party creates, uploads, posts, sends, receives, or stores on or through our services.
                            You
                            understand and agree that you may be exposed to content that might be offensive, illegal,
                            misleading, or otherwise inappropriate; none of which MID will be responsible for.</p>
                    </div>
                </div>
            </div>
            <AppFooter/>
        </div>

    );
}
